import { Menu, Text } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ShortcutAction } from 'app/modules/wallforming/components/scenes/toolbar/types/shortcutAction';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const DiscardSelection = () => {
    const { t } = useTranslation();

    const { articleInstanceSelections, discardArticleInstanceSelection } = usePlacementStore(
        useShallow((state) => ({
            articleInstanceSelections: state.articleInstanceSelections,
            discardArticleInstanceSelection: state.discardArticleInstanceSelection
        }))
    );

    const hasSelection = (() => {
        for (const _ in articleInstanceSelections) {
            return true;
        }
        return false;
    })();

    return (
        <Menu.Item
            disabled={!hasSelection}
            leftSection={
                <Icon className="action-menu-entry-decoration action-menu-entry-decoration-icon" icon="remove_selection" />
            }
            rightSection={
                <Text className="action-menu-entry-decoration-text text-right text-[13px]">{ShortcutAction.Cancellation}</Text>
            }
            onClick={() => discardArticleInstanceSelection(false)}
        >
            {t('labelDiscardSelection')}
        </Menu.Item>
    );
};
